import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'goods-categories' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
